<template>
  <div class="">
    <div class="w-full h-full fixed top-0 left-0 -z-10 bg-[#e5e7eb]"></div>
    <!-- <Header /> -->

    <AdminHeader v-if="this.userInfo.user.permission == 'super_admin'" />
      <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
      <CoordinateHeader
        v-if="this.userInfo.user.permission == 'co-ordinator'"
      />
      <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />

    <div class="p-5 lg:p-10">
      <div class="w-full h-full py-5 flex flex-col gap-5">
        <div class="flex justify-between">
          <h1 class="text-lg lg:text-2xl font-semibold dark_text">
            Student List
            <span class="">
              ({{ title }} | {{ subject_pk }}-{{ section }})
            </span>
          </h1>
          <!-- <router-link :to="{ name: 'InstructorBlogsList' }">
            <button class="bg-blues text-white py-1 px-3 rounded-lg">
              back
            </button>
            </router-link
          > -->
        </div>
        <div v-if="loading" class="flex items-center justify-center">
          <img src="@/assets/attendance/loading.gif" alt="" />
        </div>
        <div v-else class="w-full overflow-scroll">
          <table class="min-w-full" v-if="this.student_list.length > 0">
            <thead>
              <tr
                class="text-center bg-[#18469d] text whitespace-nowrap text-sm"
              >
                <th class="px-6 py-3">S.No</th>
                <th class="px-6 py-3">StudentName</th>
                <th class="px-6 py-3">TotalClassTaken</th>
                <th class="px-6 py-3">TotalClassPresent</th>
                <th class="px-6 py-3">TotalClassAbsent</th>
                <th class="px-6 py-3">Attendance %</th>

                <th
                  v-if="this.student_list[0]"
                  class="px-6 py-3"
                  v-for="(history, index) in this.student_list[0].history"
                  :key="index"
                >
                  {{ formatDate(history.date) }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(list, index) in student_list"
                :key="index"
                class="border-b border-[#afdaec] text-center whitespace-nowrap text-sm"
              >
                <td class="px-6 py-3">{{ index + 1 }}</td>
                <td class="px-6 py-3 text-left bg-gray-100">
                  <p class="font-semibold capitalize">{{ list.name }}</p>
                  <p
                    class="text-xs text-gray-600 font-medium font-sans flex items-center"
                  >
                    <img
                      src="@/assets/attendance/mail.svg"
                      alt=""
                      srcset=""
                      class="w-3 h-3 mr-1"
                    />
                    : {{ list.email }}
                    <span class="m-1">|</span>
                    <img
                      src="@/assets/attendance/phone.svg"
                      alt=""
                      srcset=""
                      class="w-3 h-3 mr-1"
                    />
                    : <span v-if="list.phone">{{ list.phone }}</span>
                    <span v-else>None</span>
                  </p>
                  <p class="text-xs text-gray-600 font-medium font-sans">
                    Enroll no :None<span class="m-1">|</span> USN :
                    {{ list.university_seat_number }}
                  </p>
                </td>

                <td class="px-6 py-3">{{ list.total_class_taken }}</td>
                <td class="px-6 py-3">{{ list.total_class_present }}</td>
                <td class="px-6 py-3">{{ list.total_class_absent }}</td>
                <td
                  class="px-6 py-3"
                  :class="[
                    list.attendance_percentage <= 74
                      ? 'bg-pink-200'
                      : list.attendance_percentage > 74 &&
                        list.attendance_percentage <= 85
                      ? 'bg-yellow-400'
                      : 'bg-green-200',
                  ]"
                >
                  {{ list.attendance_percentage }}%
                </td>
                <td
                  class="px-6 py-3"
                  v-for="(history, index) in list.history"
                  :key="index"
                  :class="{
                    'text-red-500': history.attendance_status === 'Absent',
                  }"
                >
                  {{ history.attendance_status.charAt(0).toUpperCase() }}
                </td>
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="11" class="p-6 bg-[#18469d]"></td>
              </tr>
            </tfoot>
          </table>
          <div v-else class="flex justify-center">No Data Found</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Header from "@/components/Instructor/Header.vue";
import AdminHeader from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import InstructorHeader from "@/components/Instructor/Header.vue";

import axios from "axios";
import { mapGetters } from "vuex";


export default {
  data() {
    return {
      student_list: [],
      loading: true,
    };
  },
  props: ["subject_pk", "timetable_pk", "title", "section"],
  components: {   AdminHeader,
    HodHeader,
    CoordinateHeader,
    InstructorHeader, },
  created() {
    this.getStudentsList();
  },

  computed: {
    ...mapGetters(["userInfo"]),
  },

  methods: {
    formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    async getStudentsList() {
      // if(this.user_token != null){
      // }
      await axios
        .get(
          `${process.env.VUE_APP_API_COMS}/faculty-admin/student-stats-list/${this.subject_pk}/${this.timetable_pk}/?Key=${localStorage.getItem("LmsId")}`
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.student_list = response.data.data;
            setTimeout(() => {
              this.loading = false;
            }, 600);
          }
        });
    },
  },
};
</script>

<style></style>
